<div class="mitchell1-service-assign-dialog flex-column">
  <!-- Mitchell 1 Serive Dialog header -->
  <div class="mitchell1-service-assign-dialog-header flex-between-center">
    <div class="flex-start-center">
      <i class="fal fa-user font-primary flex-center-center header-icon font-18 mr-2"></i>
      <p class="m-0 font-18 flex-column flex-center-start">
        <span class="font-18 font-bold">Confirm Import from Mitchell1</span>
        <span class="font-16 font-gray-55">
          Please assign services to items imported from Mitchell1.
        </span>
      </p>
    </div>
  </div>

  <!-- Mitchell 1 Serive Dialog -->
  <div class="mitchell1-service-assign-dialog-body">
    <div class="container p-0">
      <div class="row">
        <div class="col-12">
          <table class="table table-borderless">
            <thead>
              <tr>
                <th scope="col">Item type</th>
                <th scope="col">Items</th>
                <th scope="col">Service</th>
                <th scope="col"></th>
              </tr>
            </thead>

            <tbody>
              <tr *ngFor="let item of items; index as i">
                <td>{{itemTypeLabel && itemTypeLabel[item.type]}}</td>
                <td>{{item.title}}</td>
                <td class="position-relative">
                  <app-auto-complete id="service-name-dropdown" listId="service-name-dropdown-list"
                    label="Select a service" placeholder="Select a service" field="name" scrollHeight="180px"
                    theme="primary" editableItemIdKey="_id" editFieldPlaceholder="Enter service name"
                    editFieldLabel="Create new service" [isInvalid]="errors[item.itemSourceId]"
                    [hasError]="errors[item.itemSourceId]" [errorMessage]="errors[item.itemSourceId]"
                    [floatingLabel]="true" [hasEditableField]="true" [maxLength]="25" [hasFutureSelectionField]="false"
                    [closeOnSelection]="true" [textTruncate]="true"
                    [isDropdownIconVisible]="!serviceItemMap[item.itemSourceId]?.service?.title"
                    [hasStaticUnassignedFiled]="false" [suggestions]="serviceSuggestions" [listItemFontSize]="14"
                    [fontSize]="14" [disabled]="serviceItemMap[item.itemSourceId]?.service?.title"
                    [value]="serviceItemMap[item.itemSourceId]?.service?.title"
                    (appCompletedMethod)="handleSearch($event)" (appClear)="handleSearch('')"
                    (appSelect)="handleServiceSelect($event, item)" (appSave)="handleServiceCreate($event, item)">
                    <ng-template let-item let-editItem="editItem" appTemplate="item">
                      <div class="tag-item flex-between-center">
                        <div>
                          <span>{{ item?.title }}</span>
                        </div>

                        <div class="tag-item-action flex-end-center">
                        </div>
                      </div>
                    </ng-template>
                  </app-auto-complete>

                  <i *ngIf="serviceItemMap[item.itemSourceId]?.service?.title"
                    class="fal fa-times p-2 pointer service-cross" (click)="handleClearService(item.itemSourceId)"></i>
                </td>

                <td *ngIf="i === 0">
                  <span class="pointer">
                    <i class="fa-copy far font-16 font-primary"></i>
                    <span class="font-14 font-bold font-primary pl-2 pointer"
                      (click)="handleAssignToAll(serviceItemMap[item.itemSourceId]?.service)">Assign to all</span>
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>

  <!-- Assign technician footer -->
  <div class="tech-assign-dialog-footer flex-end-center">
    <button class="btn btn-border pointer btn-submit mr-1" (click)="handleConfirmationOnCancel()">
      Cancel
    </button>

    <button class="btn btn-primary btn-submit" [disabled]="!isSaveButtonEnabled()" (click)="handleSubmit()">
      Save
      <i class="fal fa-spinner rotate" *ngIf="isSubmitting"></i>
    </button>
  </div>
</div>
